export enum MenuItemType {
    UserLink = 1,
    Category = 2,
    Page = 3,
    Section = 4,
    Homepage = 5
}